//TODO: Make this a dynamic list that can be updated based on backend.
import { DropdownOptions } from "../components/FormFields/DropdownField";
export const UserRoles: DropdownOptions[] = [
	{ value: "manager" },
	{ value: "editor" },
	{ value: "user" },
];
